<template>
  <div ref="menuSearch" class="menu-search">
    <div class="menu-search-panel" ref="menuSearchPanel" v-show="isShow">
      <div class="menu-search-input-container">
        <el-input ref="menuSearchInput" v-model="value" placeholder="搜索" @input="searchMenu(value)">
          <span slot="suffix">
            <i  class="el-input__icon el-icon-close clear-btn" @click.stop="searchMenu('')" v-if="value">
            </i>
            <i class="el-input__icon el-icon-search"></i>
          </span>
        </el-input>
      </div>
      <div class="menu-search-content">
        <div class="result-content" v-if="value">
          <el-divider>搜索结果</el-divider>
          <div class="menu-list scrollbar" v-if="menuOptions && menuOptions.length">
            <div class="menu-item" v-for="item in menuOptions" :key="item.value" @click="selectMenu(item)">
              <span v-html="item.hitLabel"></span>
            </div>
          </div>
          <div v-else><el-empty description="找不到数据"></el-empty></div>
        </div>
        <template v-else>
          <div class="history-content" v-if="historyKeys && historyKeys.length">
            <el-divider>搜索历史</el-divider>
            <div class="content-box">
              <div style="text-align: right;">
                <el-button type="text" style="padding-top: 0;" @click.stop="clearHistoryKeys">清空历史</el-button>
              </div>
              <div class="history-container">
                <div class="history-item" v-for="item in historyKeys" :key="item" @click.stop="searchMenu(item)">
                  <div class="history-item-label">{{ item }}</div>
                  <div class="close-btn" @click.stop="delHistoryKey(item)"><i class="el-icon-close"></i></div>
                </div>
              </div>
            </div>
          </div>
          <div class="recommend-content" v-if="recommendOptions && recommendOptions.length">
            <el-divider>常用菜单</el-divider>
            <div class="content-box">
              <div style="text-align: right;">
                <el-button type="text" style="padding-top: 0;" @click.stop="clearRecommendOptions">清空</el-button>
              </div>
              <div class="recommend-container">
                <div class="recommend-item" v-for="item in recommendOptions" :key="item.value" @click="selectMenu(item)">
                  <span class="recommend-item-label">{{ item.label }}</span>
                  <div class="close-btn" @click.stop="delRecommendOption(item)"><i class="el-icon-close"></i></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <el-input :value="value" class="menu-search-trigger" v-model="value" @focus="showMenuSearchPanel" placeholder="搜索" readonly>
      <i slot="suffix" class="el-input__icon el-icon-search" @click="showMenuSearchPanel"></i>
    </el-input>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      value: "",

      // 搜索结果
      menuOptions: [],
      // 推荐项
      recommendOptions: [],
      // 历史关键字
      historyKeys: [],
    };
  },
  computed: {
    ...mapGetters(["routerMenuOptions", "user"]),
  },
  mounted() {
    document.addEventListener("click", this.hideMenuSearchPanel);
  },
  methods: {
    // 显示搜索面板
    showMenuSearchPanel() {
      this.isShow = true
      this.buildHistoryKeys();
      this.buildRecommendOptions();
      this.$nextTick(() => {
        this.$refs.menuSearchInput.focus()
      })
    },
    // 隐藏搜索面板
    hideMenuSearchPanel(e) {
      if(this.$refs.menuSearch && this.isShow){
          let isSelf = this.$refs.menuSearch.contains(e.target) || this.$refs.menuSearchPanel.contains(e.target)
          if(!isSelf){
              this.isShow = false
          }
       }
    },
    // 创建历史记录
    buildHistoryKeys() {
      let historyKeys = window.localStorage.getItem("MENU_HISTORY_KEYS_"+this.user.id);
      this.historyKeys = JSON.parse(historyKeys) || []
      // if (historyKeys) {
      //   this.historyKeys = JSON.parse(historyKeys);
      // }
    },
    // 新增历史记录
    addHistoryKey(key) {
      if (key && !this.historyKeys.find((item) => item == key)) {
        this.historyKeys.unshift(key);
        window.localStorage.setItem(
          "MENU_HISTORY_KEYS_"+this.user.id,
          JSON.stringify(this.historyKeys.splice(0, 20))
        );
      }
    },
    // 删除历史记录
    delHistoryKey(key) {
      this.historyKeys = this.historyKeys.filter(
        (item) => item != key
      );
      window.localStorage.setItem(
        "MENU_HISTORY_KEYS_"+this.user.id,
        JSON.stringify(this.historyKeys)
      );
    },
    // 清空历史记录
    clearHistoryKeys() {
      this.historyKeys = [];
      window.localStorage.removeItem("MENU_HISTORY_KEYS_"+this.user.id)
    },
    // 构建推荐菜单
    buildRecommendOptions() {
      let recommendOptions = window.localStorage.getItem("MENU_RECOMMEND_OPTIONS_"+this.user.id);
      this.recommendOptions = JSON.parse(recommendOptions) || []
      // if (recommendOptions) {
      //   this.recommendOptions = JSON.parse(recommendOptions);
      // }
    },
    // 添加推荐项
    addRecommendOption(option) {
      const recommendOption = this.recommendOptions.find(item => {
        if (!item.visitedCount) item.visitedCount = 0;
        if(item.value == option.value){
          item.visitedCount++;
          return true
        }
      })
      if (!recommendOption) {
        this.recommendOptions.push({ ...option, visitedCount: 1 })
      }
      // 排序
      this.recommendOptions = this.recommendOptions.sort(this.compareVisitedCount());

      window.localStorage.setItem(
        "MENU_RECOMMEND_OPTIONS_"+this.user.id,
        JSON.stringify(this.recommendOptions)
      );
    },
    // 比较访问量
    compareVisitedCount() {
      return (a, b) => {
        return b.visitedCount - a.visitedCount;
      }
    },
    // 删除推荐项
    delRecommendOption(option) {
      this.recommendOptions = this.recommendOptions.filter(
        (item) => item.value != option.value
      );
      window.localStorage.setItem(
        "MENU_RECOMMEND_OPTIONS_"+this.user.id,
        JSON.stringify(this.recommendOptions)
      );
    },
    // 清除推荐项
    clearRecommendOptions() {
      this.recommendOptions = [];
      window.localStorage.removeItem("MENU_RECOMMEND_OPTIONS_"+this.user.id)
    },
    // 查询菜单
    searchMenu(key) {
      this.value = key
      this.menuOptions = []
      if (key) {
        this.routerMenuOptions.forEach(item => {
          if (item.label.includes(key)) {
            this.menuOptions.push({
              label: item.label,
              hitLabel: this.replaceKeyword(item.label, key, `<span style='color: #00AEEC'>${key}</span>`),
              value: item.value,
              name: item.name,
            })
          }
        })
      }
    },
    // 高亮关键字
    replaceKeyword(text, keyword, replacement) {
      const regex = new RegExp(keyword, 'gi'); // 'gi' 表示全局搜索和忽略大小写
      return text.replace(regex, replacement);
    },
    // 选择菜单
    selectMenu(menu) {
      this.$router.push(menu.value)
      this.addHistoryKey(this.value)
      // this.addRecommendOption(menu)
      this.isShow = false
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideMenuSearchPanel)
  }
};
</script>

<style lang=scss scoped>
.menu-search {
  width: 100%;
}

.menu-search-trigger {
  /deep/input {
    border: none;
    cursor: pointer;
    background-color: #f1eeee;
    transition: 0.02s ease-in-out;

    &::placeholder {
      color: #999999;
    }
  }
  i {
    color: #0039bf;
    font-weight: bold;
    cursor: pointer;
  }
}
.menu-search-panel {
  z-index: 9999;
  position: fixed;
  font-size: 15px;
  width: 320px;
  // height: 400px;
  background-color: #fff;
  padding: 13px 0 16px;
  border: 1px solid #F1F2F3;
  border-top: none;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  // overflow: hidden;

  .menu-search-input-container {
    padding: 0 10px;
  }

  .menu-search-content {
    user-select: none;
    .result-content {
      overflow: hidden;
    }
    .history-content {
    }
    .recommend-content {}
  }
}
.menu-list {
  max-height: 300px;
  padding: 10px 0 0 0;
  .menu-item {
    height: 32px;
    display: block;
    line-height: 32px;
    font-size: 14px;
    position: relative;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    padding: 0 16px;
    margin-bottom: 4px;

    &:hover {
      background-color: #E3E5E7;
    }
  }
}
.content-box {
  padding: 0 10px;
}
.history-container {
  display: flex;
  flex-wrap: wrap;
  max-height: 80px;
  overflow: hidden;
  padding: 5px 0;
  .history-item {
    position: relative;
    box-sizing: border-box;
    height: 30px;
    padding: 7px 10px 8px;
    font-size: 12px;
    line-height: 15px;
    background: #F6F7F8;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    .history-item-label {
      max-width: 85px;
      white-space: nowrap; /* 不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      background-color: #cccccc;
      color: #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      justify-content: center;
      align-items: center;
      display: none;
      padding-top: 1px;
      transform: scale(70%) translate(50%, -50%);
      i {
        font-size: 12px;
      }
    }
    &:hover>.close-btn {
      display: flex;
    }
    &:hover {
      color: #00AEEC;
    }
  }
}
.recommend-container {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
  max-height: 160px;
  overflow: hidden;
  .recommend-item {
    position: relative;
    box-sizing: border-box;
    height: 30px;
    padding: 7px 10px 8px;
    font-size: 12px;
    line-height: 15px;
    background: #F6F7F8;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      background-color: #cccccc;
      color: #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      justify-content: center;
      align-items: center;
      display: none;
      padding-top: 1px;
      transform: scale(70%) translate(50%, -50%);
      i {
        font-size: 12px;
      }
    }
    &:hover>.close-btn {
      display: flex;
    }
    &:hover {
      color: #00AEEC;
    }
  }
}
.scrollbar {
  overflow-y: scroll;
  /* 修改垂直滚动条 */
  &::-webkit-scrollbar {
    width: 4px; /* 修改宽度 */
  }

  /* 修改滚动条轨道背景色 */
  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  /* 修改滚动条滑块颜色 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(197, 194, 194, 0.5)
  }

  /* 修改滚动条滑块悬停时的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
}
.clear-btn {
  cursor: pointer;
}
</style>
